import React from 'react';

import SubHeaderBgr from './SubHeaderBgr';
import SubHeaderEmbedded from './SubHeaderEmbedded';
import SubHeaderWidget from './SubHeaderWidget';
import SubNavLink from './SubMenuItem';
import type { SubHeaderWrapperProps } from './types';
import useSubHeader from './useSubHeader';

function SubHeader({
  title,
  titleAction,
  isSticky = true,
  subMenuItems,
  subNavVariant,
  widget,
  isQuickPicks,
}: SubHeaderWrapperProps) {
  const {
    classes,
    isMobile,
    subHeaderContainerHeight,
    subHeaderHeight,
    subHeaderWidgetOpacity,
  } = useSubHeader({ widget, isSticky, subMenuItems, subNavVariant });
  const backgroundHeight = isSticky && isMobile ? subHeaderContainerHeight : subHeaderHeight;
  const shouldAnchorBackgroundToBottom = isSticky && !isMobile;

  return (
    <div className={classes.subHeaderContainer} data-sticky-header>
      <div className={classes.subHeaderContent}>
        {titleAction ? (
          <div className={classes.titleRow}>
            <h1 className={classes.subHeaderTitle}>{title}</h1>
            {titleAction}
          </div>
        ) : (
          <h1 className={classes.subHeaderTitle}>{title}</h1>
        )}

        <SubHeaderWidget
          items={widget?.items}
          actions={widget?.actions}
          opacity={subHeaderWidgetOpacity}
        />

        {subMenuItems && subMenuItems.length > 0 && (
          <div className={classes.subNavContainer}>
            {subMenuItems.map((item) => (
              <SubNavLink key={item.href} {...item} subNavVariant={subNavVariant} />
            ))}
          </div>
        )}
      </div>
      <SubHeaderBgr
        anchorToBottom={shouldAnchorBackgroundToBottom}
        isQuickPicks={isQuickPicks}
        style={{ height: `${backgroundHeight}px` }}
        gradientHeight={isSticky && isMobile ? subHeaderHeight : undefined}
      />
    </div>
  );
}

SubHeader.Embedded = SubHeaderEmbedded;

export default SubHeader;
